<template>
  <a-spin :spinning="loading">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Buat Asset Baru</h2>
      </div>
    </div>
    <!-- <a-form> -->

    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>

          <!-- <a-button @click="changeEdittable">
            <span v-if="!editable"> <FormOutlined class="mr-2" />Edit </span>
            <span v-else> <EyeOutlined class="mr-2" />View </span>
          </a-button> -->
        </a-col>
        <a-col :span="24">
          <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="Entri Manual">
              <a-row class="mt-4" :gutter="[32, 32]">
                <a-col :span="24">
                  <div>
                    <h1 class="text-title">Customer & Location</h1>
                  </div>
                  <div>
                    <a-row :gutter="[24, 12]">
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Customer</p>
                          <a-select
                            placeholder="Pilih Customer"
                            class="w-100"
                            v-model:value="selectedCustomer"
                            @change="handleChangeCustomer"
                            allow-clear
                            show-search
                            :options="customerOptions"
                            :filter-option="filterOption"
                          >
                          </a-select>
                        </div>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Location</p>
                          <a-select
                            placeholder="Pilih Lokasi"
                            class="w-100"
                            v-model:value="selectedLocation"
                            @change="handleChangeLocation"
                            allow-clear
                            show-search
                            :options="locationOptions"
                            :filter-option="filterOption"
                            :disabled="!selectedCustomer || !dataLocation.length"
                          >
                          </a-select>
                        </div>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Room</p>
                          <a-select
                            placeholder="Pilih Room"
                            class="w-100"
                            v-model:value="selectedRoom"
                            @change="handleChangeRoom"
                            :disabled="!selectedLocation || !dataRoom.length"
                            allow-clear
                            show-search
                            :options="roomOptions"
                            :filter-option="filterOption"
                          >
                          </a-select>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div>
                    <h1 class="text-title">Asset Information</h1>
                  </div>
                  <div>
                    <a-row :gutter="[24, 12]">
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Asset Category</p>
                          <a-select
                            placeholder="Pilih Asset Category"
                            class="w-100"
                            v-model:value="selectedCategoriesAssets"
                            @change="handleChangeCategoriesAssets"
                            allow-clear
                            show-search
                            :options="assetSubCategoriesOptions"
                            :filter-option="filterOption"
                          >
                          </a-select>
                        </div>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Asset Name</p>
                          <a-input
                            placeholder="Masukkan Nama Asset"
                            v-model:value="dataPayload.name"
                          ></a-input>
                        </div>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }"> </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <div class="w-100">
                          <p style="text-align: left;" class="text-label">Brand</p>
                          <a-select
                            placeholder="Pilih Manufacturer"
                            class="w-100"
                            v-model:value="dataPayload.manufacturerId"
                            allow-clear
                            show-search
                            :options="manufactureOptions"
                            :filter-option="filterOption"
                          >
                          </a-select>
                        </div>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <p style="text-align: left;" class="text-label">Model</p>
                        <a-input
                          placeholder="Masukkan Model"
                          v-model:value="dataPayload.modelAsset"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <p style="text-align: left;" class="text-label">Product No</p>
                        <a-input
                          placeholder="Masukkan Product No"
                          v-model:value="dataPayload.productNumber"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <p style="text-align: left;" class="text-label">Serial No</p>
                        <a-input
                          placeholder="Masukkan Serial No"
                          v-model:value="dataPayload.serialNumber"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <p style="text-align: left;" class="text-label">Service Tag</p>
                        <a-input
                          placeholder="Masukkan Service Tag"
                          v-model:value="dataPayload.serviceTag"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                        <p style="text-align: left;" class="text-label">Asset Tag</p>
                        <a-input
                          placeholder="Masukkan Asset Tag"
                          v-model:value="dataPayload.assetTag"
                        ></a-input>
                      </a-col>

                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="assetCategoryId !== 4">
                        <p style="text-align: left;" class="text-label">Rack No</p>
                        <a-input
                          placeholder="Masukkan Rack No"
                          v-model:value="dataPayload.rackNumber"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="assetCategoryId !== 4">
                        <p style="text-align: left;" class="text-label">U No</p>
                        <a-input
                          placeholder="Masukkan U No"
                          v-model:value="dataPayload.uNumber"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :sm="{ span: 8 }" v-if="assetCategoryId !== 4">
                        <p style="text-align: left;" class="text-label">U Size</p>
                        <a-input
                          placeholder="Masukkan U Size"
                          v-model:value="dataPayload.uSize"
                        ></a-input>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div>
                    <h1 class="text-subtitle">Procurement Information</h1>
                  </div>
                  <div>
                    <a-row :gutter="[24, 12]">
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Tanggal Pembelian</p>

                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.procurements.purchaseDate"
                        ></a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 6 }" :span="6">
                        <p class="text-label">Nomor Pembelian</p>
                        <a-input
                          placeholder="Masukkan Nomor Pembelian"
                          v-model:value="dataPayload.procurements.No"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 10 }" :sm="{ span: 10 }">
                        <p class="text-label">Value</p>
                        <a-input
                          placeholder="Masukkan Value"
                          suffix="IDR"
                          v-model:value="formattedProcurementValue"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi</p>
                        <a-input
                          placeholder="Masukkan Garansi"
                          suffix="Month(s)"
                          v-model:value="dataPayload.procurements.warranty"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi Mulai</p>

                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.procurements.warrantyStart"
                          :disabled="dataPayload.procurements.warranty ? false : true"
                        ></a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi Berakhir</p>

                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.procurements.warrantyEnd"
                          disabled
                        ></a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :span="12">
                        <p class="text-label">Vendor</p>
                        <a-select
                          placeholder="Pilih Vendor"
                          class="w-100"
                          v-model:value="dataPayload.procurements.vendorId"
                          @change="handleChangeProcurementVendor"
                          allow-clear
                          show-search
                          :options="vendorOptions"
                          :filter-option="filterOption"
                        >
                        </a-select>
                      </a-col>

                      <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                        <p class="text-label">Email</p>
                        <a-input
                          disabled
                          placeholder="Masukkan Email"
                          v-model:value="dataPayload.procurements.email"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                        <p class="text-label">Nomor Telepon</p>
                        <a-input
                          disabled
                          placeholder="Masukkan Nomor Telepon"
                          v-model:value="dataPayload.procurements.mobileNumber"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :span="3">
                        <p class="text-label">Siklus Monitoring Asset</p>
                        <a-select
                          placeholder="Pilih Siklus Asset"
                          class="w-100"
                          v-model:value="dataPayload.maintenanceCycleId"
                        >
                          <a-select-option
                            v-for="(item, index) in cycleData"
                            :key="index"
                            :value="item.id"
                            >{{ item.name }}</a-select-option
                          >
                        </a-select>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
                <a-col :span="24" v-if="assetCategoryId !== 5 && assetCategoryId !== 2">
                  <div>
                    <h1 class="text-subtitle">Maintenance Information</h1>
                  </div>
                  <div>
                    <a-row :gutter="[24, 12]">
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Tanggal Kontrak</p>
                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.maintenances.purchaseDate"
                        ></a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 6 }" :span="6">
                        <p class="text-label">Nomor Kontrak</p>
                        <a-input
                          placeholder="Masukkan Nomor Kontrak"
                          v-model:value="dataPayload.maintenances.No"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 10 }" :sm="{ span: 10 }">
                        <p class="text-label">Value</p>
                        <a-input
                          placeholder="Masukkan Value"
                          suffix="IDR"
                          v-model:value="formattedMaintenanceValue"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi</p>
                        <a-input
                          placeholder="Masukkan Garansi"
                          suffix="Month(s)"
                          v-model:value="dataPayload.maintenances.warranty"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi Mulai</p>

                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.maintenances.warrantyStart"
                          :disabled="dataPayload.maintenances.warranty ? false : true"
                        >
                        </a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 8 }">
                        <p class="text-label">Garansi Berakhir</p>

                        <a-date-picker
                          format="DD / MM / YYYY"
                          class=" w-100"
                          v-model:value="dataPayload.maintenances.warrantyEnd"
                          disabled
                        ></a-date-picker>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :span="12">
                        <p class="text-label">Vendor</p>
                        <a-select
                          placeholder="Pilih Vendor"
                          class="w-100"
                          v-model:value="dataPayload.maintenances.vendorId"
                          @change="handleChangeMaintenancesVendor"
                          allow-clear
                          show-search
                          :options="vendorOptions"
                          :filter-option="filterOption"
                        >
                        </a-select>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                        <p class="text-label">Email</p>
                        <a-input
                          disabled
                          placeholder="Masukkan Email"
                          v-model:value="dataPayload.maintenances.email"
                        ></a-input>
                      </a-col>
                      <a-col :xs="{ span: 12 }" :sm="{ span: 6 }">
                        <p class="text-label">Nomor Telepon</p>
                        <a-input
                          disabled
                          placeholder="Masukkan Nomor Telepon"
                          v-model:value="dataPayload.maintenances.mobileNumber"
                        ></a-input>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
                <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
                  <div>
                    <h1 class="text-subtitle">Description</h1>
                  </div>
                  <a-textarea
                    v-model:value="dataPayload.description"
                    placeholder="Masukkan deskripsi asset"
                    :rows="10"
                  />
                </a-col>
                <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
                  <p style="text-align: left;" class="text-label">Note</p>
                  <a-textarea
                    placeholder="Masukkan Catatan"
                    v-model:value="dataPayload.note"
                    :rows="4"
                  ></a-textarea>
                </a-col>
                <a-col :span="24">
                  <a-row :gutter="[24, 12]">
                    <a-col :span="18"></a-col>
                    <a-col
                      :span="6"
                      class="d-flex justify-content-end align-items-center"
                      style="gap:15px"
                    >
                      <a-button @click="$router.back()">Cancel</a-button>
                      <!-- - Asset Category -> Asset Sub Category
	- Asset Name
	- Brand
	- Serial No
	- Procurement
	- Maintenance
 -->
                      <a-button
                        type="primary"
                        v-if="assetCategoryId !== 2"
                        :disabled="
                          !selectedCategoriesAssets ||
                            !dataPayload.name ||
                            !dataPayload.manufacturerId ||
                            !dataPayload.serialNumber ||
                            // Procurement
                            !dataPayload.procurements.purchaseDate ||
                            !dataPayload.procurements.No ||
                            !dataPayload.procurements.value ||
                            !dataPayload.procurements.warranty ||
                            !dataPayload.procurements.warrantyStart ||
                            !dataPayload.procurements.warrantyEnd
                          // ||
                          // Maintenance

                          // !dataPayload.maintenances.purchaseDate ||
                          // !dataPayload.maintenances.No ||
                          // !dataPayload.maintenances.value ||
                          // !dataPayload.maintenances.warranty ||
                          // !dataPayload.maintenances.warrantyStart ||
                          // !dataPayload.maintenances.warrantyEnd ||
                          // !dataPayload.maintenances.vendorId
                        "
                        @click="handleSubmit"
                        >Submit</a-button
                      >
                      <a-button
                        type="primary"
                        v-else
                        :disabled="
                          !selectedCategoriesAssets ||
                            !dataPayload.name ||
                            !dataPayload.manufacturerId ||
                            !dataPayload.serialNumber ||
                            // Procurement
                            !dataPayload.procurements.purchaseDate ||
                            !dataPayload.procurements.No ||
                            !dataPayload.procurements.value ||
                            !dataPayload.procurements.warranty ||
                            !dataPayload.procurements.warrantyStart ||
                            !dataPayload.procurements.warrantyEnd
                        "
                        @click="handleSubmit"
                        >Submit</a-button
                      >
                    </a-col>
                    <!-- <a-col
              :span="6"
              class="d-flex justify-content-end align-items-center"
              style="gap:15px"
              v-else
            >
              <a-button @click="$router.back()" >Cancel</a-button>

              <a-button
                :disabled="!selectedCustomer || !selectedLocation"
                @click="handleSubmitInfra"
                >Submit</a-button
              >
            </a-col> -->
                  </a-row>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Impor dari Excel">
              <BulkAssetUpload />
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </a-card>
    <!-- </a-form> -->
  </a-spin>
</template>

<script>
import { onMounted, ref, createVNode, computed, reactive, onBeforeMount, watch } from 'vue'
import { defineAsyncComponent } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import {
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LeftOutlined,
  FormOutlined,
  EyeOutlined,
} from '@ant-design/icons-vue'
import { message, Modal, notification, Form } from 'ant-design-vue'
import { getOne, remove, getAllPendings, update } from '@/services/axios/brivice-backend'
import apiClient from '@/services/axios'
import {
  getCustomers,
  getLocationByCustomerId,
  getRoomByCustomerId,
  getCycleAssets,
} from '../../services/axios/modc/customer'
import { getCategories, postAssets, postInfrastructure } from '../../services/axios/modc/assets'
import { getManufactures } from '../../services/axios/modc/manufacture'
import { getVendors } from '../../services/axios/modc/vendor'
import assetsFile from '@/data/modc_dump.json'
import moment from 'moment'
import { uniqueId } from 'lodash'
import BulkAssetUpload from './importExcel.vue'

const columns = [
  {
    title: 'Nama Perangkat',
    dataIndex: 'device',
    key: 'device',
    slots: { customRender: 'device' },
    width: '15%',
  },
  {
    title: 'Nama Brand',
    dataIndex: 'brand',
    key: 'brand',
    slots: { customRender: 'brand' },
  },
  {
    title: 'Nomor Produk',
    dataIndex: 'productNo',
    key: 'productNo',
    slots: { customRender: 'productNo' },
  },
  {
    title: 'Nomor Serial',
    dataIndex: 'serialNo',
    key: 'serialNo',
    slots: { customRender: 'serialNo' },
  },
]
const useForm = Form.useForm
const assetsId = [
  // FACILITIES
  7 /**Elec Pan comps*/,
  8 /**UPS comps*/,
  10 /**Generator Set comps*/,
  11 /**Battery comps*/,
  12 /**Grounding */,
  13 /**Pre AC */,
  14 /**Sta AC */,
  15 /**Fire Supp comps*/,
  16 /**Fire Sup pip */,
  17 /**Fire Ext comps*/,
  18 /**CCTV comps*/,
  19 /**Door comps*/,
  20 /**ENV comps*/,
  // ACTIVE
  22 /** Access Point */,
  23 /** Firewall */,
  24 /** Router */,
  25 /** Server */,
  26 /** Switch */,
  // PASSIVE
  3 /** RACK UNIT */,
  27 /** UTP Cable */,
  28 /** UTP Patch Panel */,
  29 /** FO Patch Panel */,
  30 /** FO Cable */,
]

export default {
  components: { LeftOutlined, BulkAssetUpload },
  setup() {
    let store = useStore()
    let route = useRoute()
    let router = useRouter()

    const assets = ref()
    // const manufactures = ref()
    const loading = ref(false)
    const catFacility = ref('Access Point')
    const facility = ref('Access-002')
    const selectedTypeofFailure = ref()
    const selectedTypeofSolving = ref()
    const selectedReparation = ref()
    const editable = ref(false)
    const componentsAssetsData = ref([])
    const componentsHardwareProcessor = ref([])
    const componentsHardwareDiskDrive = ref([])
    const componentsHardwareMemory = ref([])

    // CUSTOMER
    const selectedCustomer = ref()
    const dataCustomers = ref([])
    const selectedLocation = ref()
    const dataLocation = ref([])
    const selectedRoom = ref()
    const dataRoom = ref([])

    // CATEGORIES
    const dataCategoriesAssets = ref([])
    const selectedCategoriesAssets = ref()

    // BRAND/MANUFACTURE
    const dataManufatures = ref([])
    const selectedManufatures = ref()

    // VENDORS
    const dataVendors = ref([])
    const selectedVendors = ref()
    const selectedVendors2 = ref()

    const dataTypeofFailure = [
      'Hardware Failure',
      'Software Failure',
      'System Failure',
      'Part Failure',
      'Broken Part',
      'Other',
    ]
    const capacityOption = [
      '64 MB',
      '128 MB',
      '256 MB',
      '512 MB',
      '1 GB',
      '2 GB',
      '4 GB',
      '8 GB',
      '16 GB',
      '32 GB',
      '64 GB',
      '128 GB',
      '256 GB',
      '512 GB',
      '1 TB',
      '2 TB',
      '4 TB',
      '8 TB',
      '16 TB',
      '32 TB',
      '64 TB',
      '128 TB',
      '256 TB',
      '512 TB',
    ]
    const utpType = ['cat3', 'cat4', 'cat5', 'cat5e', 'cat6', 'cat6a', 'cat7', 'cat7a']
    const connectionType = [
      'Point to Point',
      'Point to Multiple Point',
      'Multiple Point to Multiple Point',
      'Switch Hub to Client',
    ]
    const foType = ['OM2', 'OM3', 'OM4', 'Single Mode', 'Multi Mode']
    const foConnectionType = ['Backbone', 'Horizontal', 'Patch Cord']

    const dataSoftwareType = [
      'Antivirus',
      'Database System',
      'Enterprise',
      'Graphics',
      'Operating System',
      'Spreadsheet',
      'Word Processors',
    ]

    const dataTypeofSolving = ['Reparation', 'Part Replacement', 'Reconfiguration']
    const dataReparation = ['Minor', 'Major', 'Overhaul', 'Other']
    const addTroubleshootDetail = () => {
      componentsAssetsData.value.push({
        _id: uniqueId('tbs-'),
        name: '',
        quantity: '',
        location: '',
      })
    }
    const deleteTroubleshootDetail = id => {
      componentsAssetsData.value = componentsAssetsData.value.filter(trb => trb._id !== id)
    }
    const addHardwareProcessor = () => {
      componentsHardwareProcessor.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareProcessor = id => {
      componentsHardwareProcessor.value = componentsHardwareProcessor.value.filter(
        trb => trb._id !== id,
      )
    }
    const addHardwareDiskDrive = () => {
      componentsHardwareDiskDrive.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareDiskDrive = id => {
      componentsHardwareDiskDrive.value = componentsHardwareDiskDrive.value.filter(
        trb => trb._id !== id,
      )
    }
    const addHardwareMemory = () => {
      componentsHardwareMemory.value.push({
        _id: uniqueId('tbs-'),
        manufacturerId: null,
        model: null,
        speed: null,
        threads: null,
        core: null,
      })
    }
    const deleteHardwareMemory = id => {
      componentsHardwareMemory.value = componentsHardwareMemory.value.filter(trb => trb._id !== id)
    }
    const subCategoryFromState = ref(null)
    onBeforeMount(() => {
      fetchInitialData()

    })

    const dataPayload = ref({
      accessType: null,
      airFlow: null,
      assetSubCategoryId: null,
      assetTag: null,
      availablePort: null,
      backupDuration: null,
      backupKva: null,
      backupKw: null,
      battery: null,
      batteryType: null,
      cableManagement: null,
      cells: null,
      components: [],
      connectionType: null,
      controllerStatus: null,
      coolingCapacity: null,
      coolingDesign: null,
      coolingType: null,
      core: null,
      crossConnection: null,
      customerId: null,
      deadPort: null,
      depth: null,
      diskDrives: [],
      dns: null,
      domainRole: null,
      expireDate: null,
      extenguisherType: null,
      fillDate: null,
      foType: null,
      formFactor: null,
      gateway: null,
      height: null,
      hostName: null,
      inputKva: null,
      inputKw: null,
      inputPowerKw: null,
      ipAdress: null,
      kva: null,
      kw: null,
      locationId: null,
      machineType: null,
      maintenances: {
        vendorId: null,
        email: null,
        mobileNumber: null,
        No: null,
        Date: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      },
      manufacturerId: null,
      memories: [],
      model: null,
      modelAsset: null,
      name: null,
      node: null,
      os: null,
      outputKva: null,
      outputKw: null,
      panelType: null,
      patch: null,
      phaseType: null,
      processors: [],
      procurements: {
        vendorId: null,
        email: null,
        mobileNumber: null,
        No: null,
        Date: null,
        value: null,
        warranty: null,
        warrantyStart: null,
        warrantyEnd: null,
      },
      productNumber: null,
      rackNumber: null,
      rackUnit: null,
      roomId: null,
      sensorType: null,
      serialNumber: null,
      serviceTag: null,
      softwareName: null,
      softwareType: null,
      softwareVersion: null,
      status: null,
      subnetMask: null,
      supressType: null,
      systemName: null,
      systemTrigger: null,
      totalPort: null,
      transferSwitch: null,
      uNumber: null,
      uSize: null,
      utpType: null,
      vendorId: null,
      version: null,
      voltage: null,
      weight: null,
      width: null,
      wifiName: null,
      workingPort: null,
      note: null,
    })

    const formattedMaintenanceValue = computed({
      get() {
        const value = dataPayload.value.maintenances.value
        if (value === null || value === undefined) {
          return ''
        }
        // Format angka ke string dengan pemisah ribuan
        return new Intl.NumberFormat('id-ID').format(value)
      },
      set(newValue) {
        // Ubah string berformat kembali ke angka
        const newNumber = parseInt(newValue.replace(/[^0-9]/g, ''), 10)
        dataPayload.value.maintenances.value = isNaN(newNumber) ? 0 : newNumber
      },
    })
    watch(
      [() => dataPayload.value.procurements, () => dataPayload.value.maintenances],
      ([newProcurements, newMaintenances], [oldProcurements, oldMaintenances]) => {
        // --- Logic for Procurements (This part was already correct) ---
        if (moment.isMoment(newProcurements.warrantyStart) && newProcurements.warranty) {
          const newWarrantyEnd = newProcurements.warrantyStart
            .clone()
            .add(newProcurements.warranty, 'months')

          if (!newWarrantyEnd.isSame(dataPayload.value.procurements.warrantyEnd)) {
            dataPayload.value.procurements.warrantyEnd = newWarrantyEnd
          }
        }

        // --- Corrected Logic for Maintenances ---
        // Check if warrantyStart is a valid moment object and warranty has a value
        if (moment.isMoment(newMaintenances.warrantyStart) && newMaintenances.warranty) {
          const newWarrantyEnd = newMaintenances.warrantyStart
            .clone()
            .add(newMaintenances.warranty, 'months')

          // Update the warrantyEnd date for maintenances
          if (!newWarrantyEnd.isSame(dataPayload.value.maintenances.warrantyEnd)) {
            dataPayload.value.maintenances.warrantyEnd = newWarrantyEnd
          }
        }
      },
      { deep: true },
    )
    // const { resetFields, validate, validateInfos } = useForm(dataPayload, rulesPayload)
    const cycleData = ref([])
    const customerOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Customer' }

      return [
        defaultOption,
        ...dataCustomers.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const locationOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Lokasi' }

      return [
        defaultOption,
        ...dataLocation.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const vendorOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Vendor' }

      return [
        defaultOption,
        ...dataVendors.value.map(item => ({
          value: item.id,
          label: item.name,
          ...item,
        })),
      ]
    })
    const roomOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Ruangan' }

      return [
        defaultOption,
        ...dataRoom.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const manufactureOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Ruangan' }

      return [
        defaultOption,
        ...dataManufatures.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const assetSubCategoriesOptions = computed(() => {
      const defaultOption = { value: '', label: 'Pilih Asset Category' }

      return [
        defaultOption,
        ...dataCategoriesAssets.value.map(item => ({
          value: item.id,
          label: item.name,
        })),
      ]
    })
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    const fetchInitialData = async () => {
      const customers = await getCustomers()
      const { cycle } = await getCycleAssets()
      cycleData.value = cycle
      dataCustomers.value = customers.customer.map(e => ({ name: e.name, id: e.id }))
      const categories = await getCategories()
      let catAssets
      switch (route.path.split('/').at(1)) {
        case 'active':
          catAssets = 1
          break
        case 'passive':
          catAssets = 2
          break
        case 'facilities':
          catAssets = 3
          break
        case 'software':
          catAssets = 4
          break
        case 'infra':
          catAssets = 5
          break
        case 'monitoring':
          catAssets = 6
          break

        default:
          break
      }
      dataCategoriesAssets.value = categories.categories.map(e => ({ name: e.name, id: e.id }))

      const currentRoute = route.path
        .split('/')
        .at(-2)
        .split('_')
        .join(' ')
        .split(' ')
      let strRouteCapital = ''
      currentRoute.forEach(txt => {
        strRouteCapital += txt.split('')[0].toUpperCase() + txt.slice(1) + ' '
      })

      const manufactures = await getManufactures()
      dataManufatures.value = manufactures.manufacturers.map(e => ({ name: e.name, id: e.id }))

      const vendors = await getVendors()
      dataVendors.value = vendors.vendor.map(e => ({ name: e.name, id: e.id, ...e }))
    }
    const handleChangeCustomer = async e => {
      const location = await getLocationByCustomerId(e)
      dataLocation.value = location.locations.map(e => ({ name: e.name, id: e.id }))
      dataPayload.value.customerId = e
    }
    const handleChangeLocation = async e => {
      const room = await getRoomByCustomerId(selectedCustomer.value, e)
      dataRoom.value = room.rooms.map(e => ({ name: e.name, id: e.id }))
      dataPayload.value.locationId = e
    }
    const handleChangeRoom = async e => {
      dataPayload.value.roomId = e
    }
    const assetCategoryId = ref()
    const handleChangeCategoriesAssets = async e => {
      dataPayload.value.assetSubCategoryId = e
      const filtered = dataCategoriesAssets.value.filter(el => el.id === e)
      assetCategoryId.value = filtered[0].assetCategoryId
    }
    const handleChangeProcurementVendor = async e => {
      if (!e) {
        dataPayload.value.procurements.email = ''
        dataPayload.value.procurements.mobileNumber = ''
      } else {
        const vendorProcurement = dataVendors.value.find(data => data.id == e)
        dataPayload.value.procurements.email = vendorProcurement.email
          ? vendorProcurement.email
          : ''
        dataPayload.value.procurements.mobileNumber = vendorProcurement.mobileNumber
          ? vendorProcurement.mobileNumber
          : ''
      }
    }
    const handleChangeMaintenancesVendor = async e => {
      if (!e) {
        dataPayload.value.maintenances.email = ''
        dataPayload.value.maintenances.mobileNumber = ''
      } else {
        const vendorMaintenance = dataVendors.value.find(data => data.id == e)
        dataPayload.value.maintenances.email = vendorMaintenance.email
          ? vendorMaintenance.email
          : ''
        dataPayload.value.maintenances.mobileNumber = vendorMaintenance.mobileNumber
          ? vendorMaintenance.mobileNumber
          : ''
      }
    }

    // const changeEdittable = () => {
    //   editable.value = !editable.value
    // }
    const handleSubmit = async () => {
      dataPayload.value.components = componentsAssetsData.value
      // dataPayload.value.cableManagement = dataPayload.value.cableManagement == 'yes'
      // dataPayload.value.crossConnection = dataPayload.value.crossConnection == 'yes'
      const payload = dataPayload.value
      payload.cableManagement = payload.cableManagement == 'yes'
      payload.crossConnection = payload.crossConnection == 'yes'

      const routeCat = dataCategoriesAssets.value.find(
        val => val.id == selectedCategoriesAssets.value,
      )
      handleChangeCategoriesAssets(selectedCategoriesAssets.value)
      let routeName
      switch (routeCat.name) {
        case 'Electrical Panel':
          routeName = 'electrical_panel'
          break
        case 'UPS':
          routeName = 'ups'
          break
        case 'Generator Set':
          routeName = 'generator_set'
          break
        case 'Battery':
          routeName = 'battery'
          break
        case 'Precision AC':
          routeName = 'precision_ac'
          break
        case 'Standard AC':
          routeName = 'standard_ac'
          break
        case 'Fire Suppr. Gas & Cylinder':
          routeName = 'fire_suppresion'
          break
        case 'Fire Suppr. Piping':
          routeName = 'fire_piping'
          break
        case 'Fire Extinguisher':
          routeName = 'fire_extinguisher'
          break
        case 'Security - CCTV':
          routeName = 'cctv'
          break
        case 'Security - Access Door':
          routeName = 'access_door'
          break
        case 'Environment & Facility':
          routeName = 'env_monitoring'
          break
        case 'Access Point':
          routeName = 'access_point'
          break
        case 'Firewall':
          routeName = 'firewall'
          break
        case 'Router':
          routeName = 'router'
          break
        case 'Server':
          routeName = 'server'
          break
        case 'Switch':
          routeName = 'switch'
          break
        case 'Storage':
          routeName = 'storage'
          break
        case 'UTP Cable':
          routeName = 'utp_cable'
          break
        case 'UTP Patch Panel':
          routeName = 'utp_patch_panel'
          break
        case 'FO Patch Panel':
          routeName = 'fo_patch_panel'
          break
        case 'Rack Unit':
          routeName = 'rack'
          break
        case 'Software':
          routeName = 'list'
          break

        default:
          break
      }
      const res = await postAssets(payload)
      if (res) {
        notification.success({
          message: 'Berhasil Submit',
          description: 'Data Asset Berhasil Dibuat',
        })
      } else {
        notification.error({
          message: 'Server Error',
          description: 'Internal Server Error',
        })
      }
      router.push('/' + route.path.split('/').at(1) + '/' + selectedCategoriesAssets.value)
    }
    const handleSubmitInfra = async () => {
      const payload = {
        customerId: selectedCustomer.value,
        locationId: selectedLocation.value,
      }
      const res = await postInfrastructure(payload)
      if (res) {
        notification.success({
          message: 'Berhasil Submit',
          description: 'Data Asset Berhasil Dibuat',
        })
      } else {
        notification.error({
          message: 'Server Error',
          description: 'Internal Server Error',
        })
      }
      router.push('/infrastruktur/list')
    }
    const formattedProcurementValue = computed({
      // GET: function ini dijalankan saat nilai ditampilkan
      get() {
        const value = dataPayload.value.procurements.value
        if (value === null || value === undefined) {
          return ''
        }
        // Format angka dengan pemisah ribuan (,)
        return new Intl.NumberFormat('id-ID').format(value)
      },
      // SET: function ini dijalankan saat pengguna mengetik di input
      set(newValue) {
        // Hapus semua karakter yang bukan angka (misal: koma, titik, spasi)
        const newNumber = parseInt(newValue.replace(/[^0-9]/g, ''), 10)

        // Jika hasilnya angka yang valid, update data asli. Jika tidak, set ke 0.
        dataPayload.value.procurements.value = isNaN(newNumber) ? 0 : newNumber
      },
    })
    const activeKey = ref('2')
    return {
      activeKey,
      manufactureOptions,
      roomOptions,
      filterOption,
      customerOptions,
      locationOptions,
      vendorOptions,
      // assetsFile,
      // assets,
      // getAssets,
      // getManufacture,
      // manufactures,
      loading,
      columns,
      // detail troubleshoot
      facility,
      catFacility,
      componentsAssetsData,
      componentsHardwareProcessor,
      componentsHardwareDiskDrive,
      componentsHardwareMemory,
      // Last Section
      dataTypeofFailure,
      dataTypeofSolving,
      dataReparation,
      selectedReparation,
      selectedTypeofFailure,
      selectedTypeofSolving,
      // editable,

      // getCurrentDate,
      // changeEdittable,

      addTroubleshootDetail,
      deleteTroubleshootDetail,
      addHardwareProcessor,
      deleteHardwareProcessor,
      addHardwareDiskDrive,
      deleteHardwareDiskDrive,
      addHardwareMemory,
      deleteHardwareMemory,
      handleSubmit,
      handleSubmitInfra,

      // DATA CUSTOMER
      selectedCustomer,
      dataCustomers,
      selectedLocation,
      dataLocation,
      selectedRoom,
      dataRoom,
      // FUNCTION
      handleChangeCustomer,
      handleChangeLocation,
      handleChangeRoom,
      handleChangeCategoriesAssets,
      handleChangeProcurementVendor,
      handleChangeMaintenancesVendor,
      // DATA CUSTOMER

      // CATEGORY ASSETS
      dataCategoriesAssets,
      selectedCategoriesAssets,
      // CATEGORY ASSETS

      // MANUFACTURE
      dataManufatures,
      selectedManufatures,
      // MANUFACTURE

      // VENDORS
      dataVendors,
      selectedVendors,
      selectedVendors2,
      // VENDORS

      // CAPACITY
      capacityOption,
      // CAPACITY

      // PASSIVE
      utpType,
      connectionType,
      foType,
      foConnectionType,
      // PASSIVE

      // SOFTWARE
      dataSoftwareType,
      // SOFTWARE

      // DATA PAYLOAD
      dataPayload,
      // validateInfos,
      // DATA PAYLOAD
      // dataSource,
      assetCategoryId,
      formattedProcurementValue,
      formattedMaintenanceValue,
      cycleData,
      assetSubCategoriesOptions,
    }
  },
}
</script>
<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

// . {
//   background-color: white !important;
//   input {
//     background-color: white !important;
//   }
// }
// :global(.ant-select-.ant-select:not(.ant-select-customize-input)) {
//   :global(.ant-select-selector) {
//     background-color: white !important;
//   }
// }
// .ant-input .ant- {
//   background-color: #ffffff !important;
// }
.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;

    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
